import { Skeleton } from "components/DesignSystem/Skeleton/Skeleton";

const TABLE_ROW_COUNT = 8;

export const VarianceReportSkeleton = () => (
  <div className="t-flex t-h-full t-flex-col t-gap-4">
    <div className="t-flex t-flex-col t-gap-4 t-rounded-lg t-border t-border-solid t-border-purple-10 t-bg-purple--1 t-p-5 sm:t-px-3">
      <Skeleton className="t-h-5 t-w-48" />
      <div className="t-flex t-flex-col t-gap-3">
        <Skeleton className="t-h-5 t-w-full" />
        <Skeleton className="t-h-5 t-w-2/3" />
      </div>
    </div>

    <div className="t-flex t-flex-col t-gap-5 t-rounded-lg t-border t-border-solid t-border-neutral-10 t-p-5 sm:t-px-3">
      <div className="t-flex t-items-center t-gap-4">
        <Skeleton className="t-h-5 t-w-1/4" />
        <Skeleton className="t-h-5 t-w-1/6" />
        <Skeleton className="t-h-5 t-w-1/6" />
        <Skeleton className="t-h-5 t-w-1/6" />
        <Skeleton className="t-h-5 t-w-1/6" />
      </div>
      {Array.from({ length: TABLE_ROW_COUNT }, (_, index) => (
        <div key={index} className="t-flex t-items-center t-gap-4">
          <Skeleton className="t-h-6 t-w-1/4" />
          <Skeleton className="t-h-6 t-w-1/6" />
          <Skeleton className="t-h-6 t-w-1/6" />
          <Skeleton className="t-h-6 t-w-1/6" />
          <Skeleton className="t-h-6 t-w-1/6" />
        </div>
      ))}
    </div>
  </div>
);
